var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtcb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M252.139 158.965c-17.096 68.571-86.547 110.303-155.126 93.203C28.46 235.072-13.27 165.617 3.833 97.049 20.923 28.47 90.374-13.266 158.933 3.83c68.576 17.096 110.303 86.56 93.207 155.135Z",
    fill: "#F7931A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M184.4 109.765c2.548-17.031-10.42-26.187-28.152-32.295L162 54.398l-14.044-3.5-5.6 22.464c-3.692-.92-7.484-1.788-11.252-2.648l5.64-22.612-14.036-3.5-5.756 23.064c-3.056-.696-6.056-1.384-8.968-2.108l.016-.072-19.367-4.836-3.736 15s10.42 2.388 10.2 2.536c5.687 1.42 6.715 5.184 6.543 8.168l-6.552 26.283c.393.1.9.244 1.46.468-.468-.116-.968-.244-1.484-.368l-9.183 36.82c-.696 1.728-2.46 4.32-6.436 3.336.14.204-10.208-2.548-10.208-2.548l-6.972 16.076 18.276 4.556c3.4.852 6.732 1.744 10.012 2.584l-5.812 23.335 14.028 3.5 5.755-23.087c3.832 1.04 7.552 2 11.192 2.904l-5.736 22.979 14.044 3.5 5.812-23.291c23.948 4.532 41.956 2.704 49.536-18.956 6.108-17.44-.304-27.5-12.904-34.06 9.176-2.116 16.088-8.152 17.932-20.62Zm-32.088 44.996c-4.34 17.44-33.704 8.012-43.224 5.648l7.712-30.916c9.52 2.376 40.048 7.08 35.512 25.268Zm4.344-45.248c-3.96 15.864-28.4 7.804-36.328 5.828l6.992-28.04c7.928 1.977 33.46 5.665 29.336 22.212Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtcb);
export default __webpack_public_path__ + "static/media/btcb.0f0e242d8746e591ee1001a2ef8b4c3c.svg";
export { ForwardRef as ReactComponent };